import {Node, mergeAttributes} from '@tiptap/core'

export type HtmlEmbedOptions = {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    htmlEmbed: {
      setHtmlEmbed: (options: {html: string}) => ReturnType
    }
  }
}

const HtmlEmbed = Node.create<HtmlEmbedOptions>({
  name: 'htmlEmbed',

  group: 'block',

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      html: {
        default: '',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div.raw-html-embed',
        getAttrs: (node) => {
          const element = node as HTMLElement
          return {html: element.innerHTML}
        },
      },
    ]
  },

  renderHTML({HTMLAttributes}) {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: 'raw-html-embed',
        'data-html-embed': '',
      }),
    ]
  },

  addNodeView() {
    return ({node, getPos, editor}) => {
      const dom = document.createElement('div')
      dom.classList.add('raw-html-embed')
      dom.setAttribute('data-html-embed', '')
      dom.innerHTML = node.attrs.html || ''

      dom.addEventListener('dblclick', () => {
        if (!editor.isEditable) {
          return
        }

        const newHtml = window.prompt('Edit HTML:', node.attrs.html || '')
        if (newHtml !== null && typeof getPos === 'function') {
          editor
            .chain()
            .focus()
            .command(({tr}) => {
              const pos = getPos()
              tr.setNodeMarkup(pos, undefined, {html: newHtml})
              return true
            })
            .run()
        }
      })

      return {
        dom,
        update: (updatedNode) => {
          if (updatedNode.type.name !== 'htmlEmbed') {
            return false
          }
          dom.innerHTML = updatedNode.attrs.html || ''
          return true
        },
      }
    }
  },

  addCommands() {
    return {
      setHtmlEmbed: (options) => ({commands}) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
    }
  },
})

export default HtmlEmbed
